import { PageShell } from '../components/PageShell.js';

export function PrivacyPage() {
  return (
    <PageShell>
      <article className="card mx-auto max-w-3xl space-y-4">
        <h1 className="heading-xl text-crimson">Privacy notice</h1>
        <p>
          FOIS UtsavVoice collects feedback so FESTIVALSOFINDIASTORE can improve gift boxes,
          packaging, and service. You do not need an account to submit feedback.
        </p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Ratings, comments, and optional photos are stored privately on AWS.</li>
          <li>Photo upload is optional. Images are not publicly accessible.</li>
          <li>
            Testimonial permission is your choice: named, anonymous, or private. Private feedback is
            never used in marketing.
          </li>
          <li>Feedback links expire and identify only your request, not your order in the URL.</li>
          <li>
            Celebration stories use a separate link. You choose named, anonymous, or private use,
            and FOIS reviews every story before any later publication.
          </li>
          <li>Responses are retained for 24 months unless a shorter period is configured.</li>
        </ul>
        <p>
          To request deletion or anonymization of a verified submission, contact{' '}
          <a
            className="font-semibold text-crimson underline"
            href="mailto:hello@festivalsofindiastore.com"
          >
            hello@festivalsofindiastore.com
          </a>
          .
        </p>
      </article>
    </PageShell>
  );
}
